import { Input, Text } from '@chakra-ui/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FIELD } from '../constants/field';
import FormField from './FormField';

const NameField = () => {
  const { t } = useTranslation();
  const { errors, register, trigger, formState } = useFormContext();
  const hasError = Boolean(errors[FIELD.NAME]);
  const handleChange = () => {
    if (formState.isSubmitted || hasError) {
      trigger(FIELD.NAME);
    }
  };

  return (
    <FormField label={t('member_profile.member_info.name')} hasError={hasError}>
      <Input
        name={FIELD.NAME}
        ref={register}
        onChange={handleChange}
        data-e2e-id="member-center-profile-name_field"
      />
      {hasError && (
        <Text variant="errorMessage" textAlign="right">
          {t(errors[FIELD.NAME].message, {
            field_name: t('member_profile.member_info.name'),
          })}
        </Text>
      )}
    </FormField>
  );
};

export default NameField;
